/** @type {LocalConf} */
export const _global = typeof __dirname === 'undefined' ? window : global;
